
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Select extends Vue {
	@Prop({ type: Array, required: true }) private items!: any[];
	@Prop({ type: Array, default: () => [] }) private rules!: any[];
	@Prop({ type: String, default: 'mdi-menu-down' }) private appendIcon!: string;
	@Prop({ type: String, default: '' }) private color!: string;
	@Prop({ type: String, default: '' }) private id!: string;
	@Prop({ type: String, default: 'primary' }) private itemColor!: string;
	@Prop({ type: String, default: '' }) private label!: string;
	@Prop({ type: String, default: '' }) private name!: string;
	@Prop({ type: String, default: '' }) private placeholder!: string;
	@Prop({ type: String, default: '' }) private prependInnerIcon!: string;
	@Prop({ type: String, default: '' }) private prefix!: string;
	@Prop({ type: String, default: '' }) private suffix!: string;
	@Prop({ type: String, default: '' }) private hint!: string;
	@Prop({ type: [String, Array, Object], default: '' }) private customClass!: string | string[] | object;
	@Prop({ type: [String, Array], default: () => [] }) private errorMessages!: string | string[];
	@Prop({ type: [String, Array], default: () => [] }) private messages!: string | string[];
	@Prop({ type: Boolean, default: false }) private clearable!: boolean;
	@Prop({ type: Boolean, default: false }) private disabled!: boolean;
	@Prop({ type: Boolean, default: false }) private multiple!: boolean;
	@Prop({ type: Boolean, default: false }) private outlined!: boolean;
	@Prop({ type: Boolean, default: false }) private persistentHint!: boolean;
	@Prop({ type: Boolean, default: false }) private returnObject!: boolean;
	@Prop({ type: [Boolean, String], default: false }) private hideDetails!: boolean | string | undefined;
	@Prop({ type: Object, default: () => ({}) }) private menuProps!: object;
	@Prop({ type: [String, Array, Function], default: 'disabled' }) private itemDisabled!: string | any[] | Function;
	@Prop({ type: [String, Array, Function], default: 'text' }) private itemText!: string | any[] | Function;
	@Prop({ type: [String, Array, Function], default: 'value' }) private itemValue!: string | any[] | Function;
	@Prop({ default: undefined }) private attach!: any;
	@Prop({ default: undefined }) private value!: any;

	$refs!: {
		select: any;
	};

	/**
	 * Override v-select's onClick to toggle the menu instead of always opening it
	 *
	 * @return {void}
	 */
	private mounted(): void {
		const select = this.$refs.select;

		if (select) {
			const originalOnClick = select.onClick.bind(select);

			select.onClick = (e: MouseEvent) => {
				if (select.isMenuActive) {
					select.isMenuActive = false;
					select.blur();
					return;
				}

				originalOnClick(e);
			};
		}
	}

	/**
	 * Toggle menu visibility when clicking append icon and emit click:append event
	 *
	 * @param {MouseEvent} event
	 * @return {void}
	 */
	private onClickAppend(event: MouseEvent): void {
		this.$emit('click:append', event);
		if (this.$refs.select) {
			this.$refs.select.isMenuActive = !this.$refs.select.isMenuActive;
		}
	}
}
